//@ts-check

import ThemeButton from 'components/AntdFormInputs/theme-button';
import { parseHtml } from 'helpers';
import React, { useEffect, useState } from 'react';
import { Check, Copy, X } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAiContext,
  getContent,
  getOpenModal,
  setContent,
  setEditorValue,
  setOpenModal,
} from 'store/ai-modal';
import TypingEffect from './typing-effect';
import { TbPlaylistAdd } from 'react-icons/tb';
import { useClipboard } from 'hooks/use-clipboard';
import unitsApi from 'api/unitsApi';
import AiStar from '@core/icons/ai-star';

const AiModalPopup = () => {
  const isOpenModal = useSelector(getOpenModal);
  const { clipboardCopy, copied } = useClipboard();
  const aiContext = useSelector(getAiContext);
  const isContent = useSelector(getContent);
  const dispatch = useDispatch();

  const [suggestion, setSuggestion] = useState(null);
  const [loading, setLoading] = useState(false);

  const toneOptions = {
    general: 'General',
    formal: 'Formal',
    funny: 'Funny',
    conversational: 'Conversational',
    professional: 'Professional',
    persuasive: 'Persuasive',
    motivational: 'Motivational',
    sarcastic: 'Sarcastic',
    poetic: 'Poetic',
    simple: 'Simple',
    technical: 'Technical',
    storytelling: 'Storytelling',
    excited: 'Excited',
  };

  const handleClearTexts = () => {
    setSuggestion(null);
    dispatch(setContent(null));
    dispatch(setOpenModal(false));
  };

  useEffect(() => {
    if (isOpenModal) {
      handlePromptSubmit('general');
    }
  }, [isOpenModal]);

  const handlePromptSubmit = async (tone) => {
    if (typeof isContent === 'string' && isContent.length > 10) {
      setLoading(true);
      try {
        const response = await unitsApi.contentImprovement({
          content: isContent,
          tone: tone,
        });
        setSuggestion(response);
      } catch (error) {
        console.error(
          'Error fetching suggestion:',
          error.response?.data || error.message,
        );
        setSuggestion('❌ Error fetching suggestion');
      } finally {
        setLoading(false);
      }
    } else {
      setSuggestion('');
    }
  };

  const handleCopy = () => {
    if (suggestion) {
      clipboardCopy(suggestion);
      setSuggestion('');
    }
  };

  const handleInsert = () => {
    if (suggestion && aiContext?.full && aiContext?.selectedHtml) {
      const replacedHtml = aiContext.full.replace(
        aiContext.selectedHtml,
        suggestion,
      );
      dispatch(setEditorValue(replacedHtml));
      dispatch(setOpenModal(false));
    } else if (suggestion) {
      dispatch(setEditorValue(suggestion));
      dispatch(setOpenModal(false));
    }
    setSuggestion('');
  };
  return (
    <>
      {isOpenModal ? (
        <div className="ai-popup-wrapper">
          <div className="ai-gradient-bg" />
          <div className="ai-modal">
            <div className="ai-header-modal">
              <h2>Editor AI</h2>
              <ThemeButton
                padding="4px 4px"
                onClick={handleClearTexts}
                variant="cancel"
              >
                <X />
              </ThemeButton>
            </div>
            <hr />
            <section className="ai-text-editor-placeholder">
              {isContent ? (
                <div className="texteditor-replytext">
                  {parseHtml(isContent)}
                </div>
              ) : (
                'No content found. Please enter some text...'
              )}
              {suggestion ? <hr /> : null}
              {loading ? (
                ''
              ) : suggestion ? (
                <>
                  <div className="custom-bot-reply">
                    
                    <AiStar/>
                  
                    <h6 className="mb-0">AI Assistant</h6>
                  </div>
                  <div className="ai-model-replytext">
                    <TypingEffect text={suggestion} />
                    <div className="copy-insert-button mt-2">
                      <button
                        className="custom-copy-insert"
                        title={copied ? 'Copied' : 'Copy'}
                        onClick={handleCopy}
                      >
                        {copied ? <Check size={14} /> : <Copy size={14} />}
                      </button>
                      <button
                        className="custom-copy-insert"
                        title="Insert to Editor"
                        onClick={handleInsert}
                      >
                        <TbPlaylistAdd size={18} />
                      </button>
                    </div>
                  </div>
                </>
              ) : null}
            </section>
            <hr />
            {loading ? (
              <div className="custom-thinking-loader">
                <img src={'/images/rippleloading.svg'} height={60} />
              </div>
            ) : (
              <div className="ai-actions">
                {Object.entries(toneOptions).map(([tone, label]) => (
                  <button
                    key={tone}
                    className="ai-cancel"
                    onClick={() => handlePromptSubmit(tone)}
                  >
                    {label}
                  </button>
                ))}
              </div>
            )}
            <p className="ai-hint">Try: General, Friendly, Change tone, etc.</p>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AiModalPopup;
